import {getProfileUrl} from "#/src/utils/profile-url";
import {useData} from "vike-react/useData";
import {ApiBlogPostData, ApiUserIntegration} from "#/src/definitions/ApiDefinitions";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {getUserImageByIntegrationType} from "#/src/utils/social-utils";
import styled from "@emotion/styled";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

const Bio = styled.p`
  white-space: pre-wrap;
`;

export function ArticleAuthor() {
  const {data: postData} = useData() as DataWrapped<ApiBlogPostData>;

  function render() {
    return <div className="author-widget">
      <div className="author">
        <AvatarWithFallback user={postData.article.author} className={"avatar avatar-120"}/>
      </div>
      <div className="author-content">
        <a href={getProfileUrl(postData.article.author)} className="author-link">{postData.article.author.username} <span>Autor artykułu</span></a>
        <Bio>{postData.article.author.bio}</Bio>
        {renderSocials()}
      </div>
    </div>
  }

  function renderSocials() {
    return <div className="author-content-social">
      {postData.article.authorSocials.map((integration: ApiUserIntegration) => {
        return <a key={integration.id} href="#">
          {getUserImageByIntegrationType(integration.integrationType)}
        </a>
      })}
    </div>
  }

  return render();
}